import { gql } from 'apollo-boost';

export const fragments = {
	
	ACCOUNT: {
		QUERY_RETURN: `id firstName lastName`,
	}
};

export const queries = {
	
	GET_ACCOUNT: ( returnQueryString = fragments.ACCOUNT.QUERY_RETURN ) => gql`
        query GetAccount( $id: Uuid! ){
            accounts( where: { id: { eq: $id } } )  {
                ${ returnQueryString }
            }
        }`,
	
};

export const mutations = {};

export const AccountQueries = {
	fragments,
	queries,
	mutations,
};
